import { NavRoute } from "./models/nav.route";
import { ListVeiculosComponent } from "./routes/veiculos/list/list-veiculos.component";
import { ListControleFinancasComponent } from "./routes/controle-financas/list/list-controle-financas.component";
import { ListUsuariosComponent } from "./routes/usuarios/list/list-usuarios.component";
import { ConfiguracoesComponent } from "./routes/configuracoes/configuracoes.component";
import { PontoEletronicoComponent } from "./routes/ponto-eletronico/ponto-eletronico.component";
import { LembretesComponent } from "./routes/lembretes/lembretes.component";
import { ControlePesosComponent } from "./routes/controle-pesos/controle-pesos.component";
import { TarefasComponent } from "./routes/tarefas/tarefas.component";

export const TITLE = "ERP";

export const RoleCnf = "ERP-Controle-Financas";
export const RoleCnb = "ERP-Conta-Bancaria";
export const RoleAbs = "ERP-Abastecimentos";
export const RolePte = "ERP-Ponto-Eletronico";
export const RoleAgt = "ERP-Agendador-Tarefas";
export const RolePes = "ERP-Controle-Peso";
export const RoleTar = "ERP-Tarefas";
export const RoleAdm = "ERP-Administrador";
export const RoleDev = "Desenvolvedor";

export const LevelNil = undefined;
export const LevelCnf = [RoleCnf, RoleAdm, RoleDev];
export const LevelCnb = [RoleCnb, RoleAdm, RoleDev];
export const LevelAbs = [RoleAbs, RoleAdm, RoleDev];
export const LevelPte = [RolePte, RoleAdm, RoleDev];
export const LevelAgt = [RoleAgt, RoleAdm, RoleDev];
export const LevelPes = [RolePes, RoleAdm, RoleDev];
export const LevelTar = [RoleTar, RoleAdm, RoleDev];
export const LevelAdm = [RoleAdm, RoleDev];
export const LevelDev = [RoleDev];

export const ROUTES: readonly NavRoute[] = [
  {
    icon: "analytics",
    name: "Controle Finanças",
    route: "controle-financas",
    activeRoutes: ["controle-financa", "controle-financa-movimentos-filtro"],
    component: ListControleFinancasComponent,
    authLevel: LevelCnf
  },
  {
    icon: "group",
    name: "Usuários",
    route: "usuarios",
    activeRoutes: ["novo-usuario", "usuario"],
    component: ListUsuariosComponent,
    authLevel: LevelAdm
  },
  {
    icon: "directions_car",
    name: "Veículos",
    route: "veiculos",
    activeRoutes: ["novo-veiculo", "veiculo", "veiculos-sem-usuario"],
    component: ListVeiculosComponent,
    authLevel: LevelAbs
  },
  {
    icon: "schedule",
    name: "Ponto Eletrônico",
    route: "ponto-eletronico",
    component: PontoEletronicoComponent,
    authLevel: LevelPte
  },
  {
    icon: "notifications_active",
    name: "Lembretes",
    route: "lembretes",
    component: LembretesComponent,
    authLevel: LevelAgt
  },
  {
    icon: "monitor_heart",
    name: "Controle de Peso",
    route: "controle-pesos",
    component: ControlePesosComponent,
    authLevel: LevelPes
  },
  {
    icon: "view_column",
    name: "Tarefas",
    route: "tarefas",
    component: TarefasComponent,
    authLevel: LevelTar
  },
  {
    icon: "settings",
    name: "Configurações",
    route: "configuracoes",
    component: ConfiguracoesComponent,
    authLevel: LevelAdm
  }
];
